<template>
    <rkm-modal
        v-if="loaded"
        extra-large
        ref="RkmModal"
        :title="`Configuração de SMS - ${item && item.nomeFantasia}`"
    >
        <rkm-form
            ref="RkmFormSms"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="4">
                    <rkm-form-input
                        :validations="validations.diaAntecedencia"
                        label="Dias de antecedência"
                        number
                        v-model="model.diaAntecedencia"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-date-picker
                        :end-validations="validations.endDate"
                        :range-inline="false"
                        :start-validations="validations.startDate"
                        end-label="Até"
                        range
                        start-label="Período de envio de"
                        v-model="model.periodoEnvio"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-area
            no-margin-top
            title="Exame"
            type="fieldset"
        >
            <rkm-form ref="RkmForm">

                <rkm-row class="flex-nowrap">
                    <rkm-col
                        v-if="hasKitsExames()"
                        class="rkm-col"
                        cols="3"
                    >
                        <rkm-area
                            title="Grupos"
                            no-margin-top
                        >
                            <rkm-form-checkbox
                                v-if="gruposParametrizados.length > 1"
                                :indeterminate="indeterminate"
                                :value="true"
                                @change="checkUncheckAll"
                                v-model="checkedAll"
                            >
                                TODOS
                            </rkm-form-checkbox>

                            <rkm-form-checkbox
                                v-for="(kit, i) in gruposParametrizados"
                                v-bind:key="`rkm-form-checkbox-kit-${i}`"
                                :class="'rkm-form-checkbox' + (i === gruposParametrizados.length - 1 ? '' : ' mb-1')"
                                :id="'popover-' + i"
                                :indeterminate="handleIndeterminate(kit)"
                                @change.native="handleKitChange($event, kit)"
                                v-model="kit.checked"
                            >
                                {{ kit.nome }}
                            </rkm-form-checkbox>

                            <div class="popovers-geral-wrapper">

                                <rkm-popover
                                    v-for="(kit, i) in gruposParametrizados"
                                    :key="i"
                                    :target="'popover-' + i"
                                    :show="true"
                                    triggers="hover"
                                    customClass="exame-popover"
                                >
                                    <div class="scrollable-popover">
                                        <rkm-form-checkbox
                                            v-for="(exame, j) in kit.exames"
                                            :key="`rkm-form-checkbox-exame-${j}`"
                                            v-model="exame.checked"
                                            @change.native="handleItemKitChange($event, exame)"
                                        >
                                            {{ exame.nome }}
                                        </rkm-form-checkbox>
                                    </div>
                                </rkm-popover>
                            </div>
                        </rkm-area>
                    </rkm-col>

                    <rkm-col :cols="hasKitsExames() ? 9 : 12">
                        <rkm-row>
                            <rkm-col class="flex-grow-1">
                                <rkm-form-input-autocomplete
                                    :request-query-string-params="autocompletesRequestParams.exame.queryString"
                                    :repository="repositories.exame"
                                    :searchFields="fields.autocompletes.exame"
                                    :text-field="e => e.codigo ? `${e.codigo} - ${e.nome}` : `${e.nome}`"
                                    :validations="validations.exame"
                                    label="Exame"
                                    v-model="exame"
                                />
                            </rkm-col>
                            <rkm-col class="flex-grow-0 text-nowrap">
                                <rkm-button
                                    :label="false"
                                    color="primary"
                                    @click.stop="handleAdd"
                                >
                                    Incluir
                                </rkm-button>
                                <rkm-button
                                    :label="false"
                                    @click.stop="resetForm"
                                >
                                    Limpar
                                </rkm-button>
                            </rkm-col>
                        </rkm-row>
                        <rkm-row>
                            <rkm-col>
                                <rkm-list
                                    :items="examesOrdenados"
                                    hide-filters
                                    hide-pagination
                                >
                                    <template v-slot="{ item }">
                                        {{ item.nome }}
                                    </template>

                                    <template v-slot:trailling="{ item }">
                                        <rkm-button
                                            @click.stop="deleteExame(item)"
                                            color="danger"
                                            title="Excluir"
                                            small
                                        >
                                            <rkm-icon icon="trash" />
                                        </rkm-button>
                                    </template>
                                </rkm-list>
                            </rkm-col>
                        </rkm-row>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel">
                Cancelar
            </rkm-button>

            <rkm-button
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {error, object, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

//Enums
import tipoExame from '@/enums/parametrizacao/tipoExame'

export default {
    computed: {
        searchFields() {
            return [
                {key: 'especialidade.nome', searchable: true},
            ]
        },
        validations() {
            return {
                diaAntecedencia: {
                    required: true,
                    max: 3,
                    max_value: 365,
                },
                startDate: {required: true},
                endDate: {required: true},
                exame: {required: true},
            }
        },
        gruposParametrizados() {

            const grupos = this.clone(this.data.form.grupos)

            return grupos
        },
        autocompletesRequestParams() {

            return {
                exame: {
                    queryString: {
                        filtrar_ativos: true,
                        tipo_id: this.enums.tipoExame.EXAME_IMAGEM,
                    }
                }
            }
        },
        fields() {

            return {
                autocompletes: {
                    exame: [
                        { key: 'codigo', searchable: true },
                        { key: 'nome', searchable: true }
                    ],
                }
            }
        },
        examesOrdenados() {

            if (!this.exames || !Array.isArray(this.exames)) return [];

            return [...this.exames].sort((a, b) => {

                const nomeA = a.nome.toLowerCase();
                const nomeB = b.nome.toLowerCase();

                if (nomeA < nomeB) return -1;
                if (nomeA > nomeB) return 1;
                return 0;
            });
        }
    },
    created() {
        this.repositories = {
            especialidade: this.getConectaSusRepository('cadastro.especialidade'),
            exame: this.getConectaSusRepository('parametrizacao.exame'),
        }
    },
    data: () => ({
        item: null,
        exames: [],
        model: {
            diaAntecedencia: null,
            especialidade: null,
            especialidades: [],
            periodoEnvio: {
                start: null,
                end: null,
            },
        },
        others: {moment},
        exame: null,
        loaded: false,
        enums: {
            tipoExame,
        },
        checkedAll: false,
        indeterminate: false,
    }),
    methods: {
        open(item) {

            this.item = item

            if (item) {
                const model = this.clone(item.sms)

                this.model.diaAntecedencia = model.diaAntecedencia,
                this.model.periodoEnvio.start = model.periodoEnvio.start ? this.others.moment(model.periodoEnvio.start, 'DD/MM/YYYY').format('YYYY-MM-DD') : null
                this.model.periodoEnvio.end = model.periodoEnvio.end ? this.others.moment(model.periodoEnvio.end, 'DD/MM/YYYY').format('YYYY-MM-DD') : null
                this.exames = model.exames
            }

            this.loaded = true

            this.$nextTick().then(() => this.$refs.RkmModal.show())
        },
        destroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir a especialidade?', async () => {
                this.model.especialidades.splice(index, 1)
            })
        },
        save() {
            this.$refs.RkmFormSms.validate()
                .then(valid => {
                    if (valid === false) return

                    if(this.exames.length === 0) {
                        this.showAlert('É necessário cadastrar ao menos um exame.', 'Atenção')
                        return
                    }

                    if (this.item.sms) {
                        this.item.sms.diaAntecedencia = this.model.diaAntecedencia

                        this.item.sms.periodoEnvio = {
                            start: this.model.periodoEnvio.start ? this.others.moment(this.model.periodoEnvio.start).format('DD/MM/YYYY') : null,
                            end: this.model.periodoEnvio.end ? this.others.moment(this.model.periodoEnvio.end).format('DD/MM/YYYY') : null,
                        }

                        this.item.sms.exames = this.exames
                    } else {
                        this.item.sms = {
                            diaAntecedencia: this.model.diaAntecedencia,
                            periodoEnvio: {
                                start: this.others.moment(this.model.periodoEnvio.start).format('DD/MM/YYYY'),
                                end: this.others.moment(this.model.periodoEnvio.end).format('DD/MM/YYYY'),
                            },
                            exames: this.exames,
                        }
                    }

                    this.$refs.RkmModal.hide()
                })
        },
        hasKitsExames() {
            return this.gruposParametrizados && this.gruposParametrizados.length > 0
        },
        handleIndeterminate(kit) {

            const indeterminate = kit.exames.some(exameKit => {
                return !!this.exames.find(examePedido => (examePedido.id === exameKit.id) || (examePedido.exameId === exameKit.id))
            })

            const checked = kit.exames.every(exameKit => {
                return !!this.exames.find(examePedido => (examePedido.id === exameKit.id) || (examePedido.exameId === exameKit.id))
            })

            if (indeterminate === true && checked === false) {
                return true
            }

            kit.checked = checked

            return false
        },
        async handleItemKitChange(event, exame) {
            const { checked } = event.target

            if (checked) {
                this.exame = exame;
                await this.handleAddKit();
            }
            else {

                exame.checked = false

                const index = this.exames.findIndex(e => ((e.id === exame.id) || (e.id === exame.exameId)))

                this.exames.splice(index, 1)
            }
        },
        async handleAddKit() {

            this.gruposParametrizados.map(k => k.exames.map(e => e.id === this.exame.id && (e.checked = true)))

            const exameadicionado = this.add(true);

            if(exameadicionado.exame) {
                this.exames.push(this.clone(this.prepareExame(exameadicionado.exame)))
            }

            this.resetForm();

        },
        handleAdd() {

            this.$refs.RkmForm.validate().then(valid => {

                if (!valid) return

                this.gruposParametrizados.map(k => k.exames.map(e => e.id === this.exame.id && (e.checked = true)))

                this.$nextTick().then(() => this.add())
            })
        },
        resetForm() {

            this.exame = null
            this.$nextTick(() => this.$refs.RkmForm.resetValidator())
        },
        handleKitChange(event, kit) {

            const { checked } = event.target

            if (checked) {
                kit.exames.map(async exame => {
                    if (!this.exames.find(e => (e.id === exame.id) || (e.exameId === exame.id))) {

                        this.exame = exame
                        await this.handleAddKit()
                    }
                })
            }
            else {

                kit.exames.map(exame => {

                    const index = this.exames.findIndex(e => (e.id === exame.id) || (e.exameId === exame.id))

                    if (index >= 0) {

                        exame.checked = false

                        this.exames.splice(index, 1)
                    }
                })
            }
        },
        add(adicionadoPorKit = false) {

            const existe = this.exames.find(exame => exame.id === this.exame.id)

            if (existe) {

                this.showAlert(`O exame <strong>${this.exame.nome}</strong> já está presente na listagem.`, 'Atenção')
                this.resetForm()

                return
            }

            const param = {
                id: this.exame.id,
                nome: this.exame.nome,
                codigo: this.exame.codigo,
            }

            if(adicionadoPorKit) {
                return { "exame": param };
            }

            this.exames.push(this.clone(this.prepareExame(param)))
            this.resetForm()
        },
        prepareExame(exameKit) {

            const exame = this.clone(exameKit)
            delete exame.checked

            return exame
        },
        deleteExame(item) {

            const objId = this.exames.findIndex((obj => (obj.id == item.id || obj.id == item.exameId) && obj.nome == item.nome));

            const destroy = async () => {

                this.exames.splice(objId, 1)
                this.gruposParametrizados.map(k => k.exames.map(e => ((e.id === item.id) || (e.id === item.exameId)) && (e.checked = false)))
            }

            this.showDeleteConfirmation(`Deseja realmente excluir o exame <strong>${ item.nome }</strong> da lista?`,
                destroy)
        },
        checkUncheckAll(value) {

            this.gruposParametrizados.forEach(kit => {

                if (value) {

                    kit.exames.map(async exame => {
                        if (!this.exames.find(e => (e.id === exame.id) || (e.exameId === exame.id))) {

                            this.exame = exame
                            await this.handleAddKit()
                        }
                    })
                } else {

                    kit.exames.map(exame => {

                        const index = this.exames.findIndex(e => (e.id === exame.id) || (e.exameId === exame.id))

                        if (index >= 0) {

                            exame.checked = false

                            this.exames.splice(index, 1)
                        }
                    })
                }
            })
        },
    },
    mixins: [error, object, repository, stringCase],
    props: {
        data: { type: Object, required: true },
    },
}
</script>

<style scpped>
.scrollable-popover {
    max-height: 500px;
    overflow-y: auto;
}
.exame-popover {
    max-width: 100%!important;
}
</style>